import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useServiceStatuses = () => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  if (!values) {
    setValues([
      { label: t('FILTERS.active'), value: 'Y' },
      { label: t('FILTERS.notActive'), value: 'N' },
    ]);
  }

  return values;
};

export { useServiceStatuses };
